import React from 'react';
import PropTypes from 'prop-types';
import GridCard from './GridCard';
import { Typography, Box } from '@mui/material';
import { MusicNote, LibraryMusic, Album, Person } from '@mui/icons-material';

const GenreCard = ({ genre }) => {
  return (
    <GridCard
      title={genre.name || 'Unknown Genre'}
      art_url={genre.art_url || null}
      tags={[]}
      redirectTo={`/genres?genre=${encodeURIComponent(genre.name || '')}`}
      showFollowOption={false}
      hideArt={true}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <MusicNote sx={{ fontSize: 16, color: 'primary.main' }} />
        <Typography variant="body2" color="text.secondary">
          {genre.track_count || 0} tracks
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <LibraryMusic sx={{ fontSize: 16, color: 'primary.main' }} />
        <Typography variant="body2" color="text.secondary">
          {genre.set_count || 0} sets
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <Person sx={{ fontSize: 16, color: 'primary.main' }} />
        <Typography variant="body2" color="text.secondary">
          {genre.artist_count || 0} artists
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <Album sx={{ fontSize: 16, color: 'primary.main' }} />
        <Typography variant="body2" color="text.secondary">
          {genre.label_count || 0} labels
        </Typography>
      </Box>
      {genre.description && (
        <Box mt={1}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: '0.75rem',
              lineHeight: 1.2,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {genre.description}
          </Typography>
        </Box>
      )}
    </GridCard>
  );
};

GenreCard.propTypes = {
  genre: PropTypes.shape({
    name: PropTypes.string,
    permalink: PropTypes.string,
    art_url: PropTypes.string,
    track_count: PropTypes.number,
    set_count: PropTypes.number,
    artist_count: PropTypes.number,
    description: PropTypes.string,
  }).isRequired,
};

export default GenreCard;
